import api from './api';

const stageService = {
  /**
   * Fetches stages for the current user's profile and project (profile-filtered by API).
   * @param {string} [projectCode] - Optional project code to scope stages (e.g. '0198-23'); refetch when project changes.
   */
  async getStages(projectCode) {
    const params = {};
    if (projectCode) params.projectCode = projectCode;
    const response = await api.get('/stage', { params });
    return response.data;
  },

  /**
   * Fetch stage-wise visit counts for current profile + project.
   * @param {string} [projectCode]
   */
  async getVisitStageCounts(projectCode) {
    const params = {};
    if (projectCode) params.projectCode = projectCode;
    const response = await api.get('/visit/stage-counts', { params });
    return response.data;
  },

  /**
   * All StageMst rows for the project (no profile filter). Used for CRF header reviewer labels by project.
   * @param {string} [projectCode] - Project code (e.g. '0131-25'); session default used if omitted.
   */
  async getAllStagesForProject(projectCode) {
    const params = { all: 'true' };
    if (projectCode) params.projectCode = projectCode;
    const response = await api.get('/stage', { params });
    return response.data;
  },

  /**
   * Stages for CRF Associated field configuration: project StageMst excluding Schedule (101) and Completed (9999).
   * @param {string} [projectCode]
   */
  async getStagesForCrFAssociation(projectCode) {
    const params = {};
    if (projectCode) params.projectCode = projectCode;
    const response = await api.get('/stage/crf-association', { params });
    return response.data;
  },
};

export default stageService;
